var map = {
	"./celery.svg": "3aa0",
	"./crustacean.svg": "1de3",
	"./egg.svg": "23e0",
	"./fish.svg": "b53e",
	"./gluten.svg": "a3b2",
	"./lactose.svg": "b323",
	"./lupin.svg": "f4c0",
	"./meat.svg": "293a",
	"./mollusc.svg": "9858",
	"./mustard.svg": "4983",
	"./nuts.svg": "7d9a",
	"./peanut.svg": "58ad",
	"./sesame.svg": "cf57",
	"./soy.svg": "4c96",
	"./sugarfree.svg": "59eb",
	"./sulphite.svg": "de21",
	"./vegan.svg": "594f",
	"./vegetarian.svg": "4a09"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "01ed";